'use strict'

const $ = window.jQuery;

export default function () {
    // Popin
    $('.card-collaborator.clickable').on('click', function () {
        const $target = $(`#temoignage-${$(this).data('temoignage')}`);

        $('body').addClass('noscroll');
        $target.addClass('is-active');

        $target.find('.collaborator-popin__content').niceScroll({
            autohidemode: false,
            background: '#C7CBD0',
            cursorcolor: '#c99d66',
            cursorborder: '0',
            cursorborderradius: '0',
            cursorwidth: '3px',
            railalign: 'left',
            railpadding: {
                top: 0, right: 0, left: 0, bottom: 40
            }
        });
    });

    $('.collaborator-popin__close').on('click', function () {
        $('.collaborator-popin').removeClass('is-active');
        $('body').removeClass('noscroll');
    });
};
